import { bl_dgmkt_project_channel_link_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class DgMktProjectChannelLinkContainerModel extends BaseContainerModel {
  bl_dgmkt_project_channel_link: bl_dgmkt_project_channel_link_RowClass =
    new bl_dgmkt_project_channel_link_RowClass();
}
